import { Link } from 'react-router-dom';
import { ArrowUpDown } from 'lucide-react';

const noteColor = (v) => {
  if (v <= 4) return 'bg-red-100 text-red-700';
  if (v <= 7) return 'bg-orange-100 text-orange-700';
  return 'bg-green-100 text-green-700';
};

const moyenneColor = (v) => {
  if (v < 5) return 'text-red-600 font-bold';
  if (v < 8) return 'text-orange-600 font-bold';
  return 'text-green-600 font-bold';
};

// Grille détaillée : toutes les notes, une colonne par catégorie / item
export const GrilleDetaillee = ({ rows, columns, calcMoyenne, onSort, sortCol }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-xs" data-testid="carnet-general-table">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            <th className="sticky left-0 z-10 bg-slate-50 px-3 py-2 text-left font-semibold text-slate-600 cursor-pointer hover:bg-slate-100 whitespace-nowrap" onClick={() => onSort('nim')}>
              NIM {sortCol === 'nim' && <ArrowUpDown className="h-3 w-3 inline ml-1" />}
            </th>
            <th className="sticky left-[60px] z-10 bg-slate-50 px-3 py-2 text-left font-semibold text-slate-600 cursor-pointer hover:bg-slate-100 whitespace-nowrap min-w-[140px]" onClick={() => onSort('nom')}>
              Stagiaire {sortCol === 'nom' && <ArrowUpDown className="h-3 w-3 inline ml-1" />}
            </th>
            {columns.map(col => (
              <th key={col.key} className="px-2 py-2 text-center font-semibold text-slate-600 whitespace-nowrap border-l border-slate-100">
                <div className="text-[10px] text-slate-400 leading-tight">{col.categorie}</div>
                <div className="text-[11px] leading-tight">{col.item}</div>
              </th>
            ))}
            <th className="px-3 py-2 text-center font-bold text-slate-700 cursor-pointer hover:bg-slate-100 whitespace-nowrap border-l-2 border-slate-300" onClick={() => onSort('moyenne')}>
              Moy. {sortCol === 'moyenne' && <ArrowUpDown className="h-3 w-3 inline ml-1" />}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, idx) => {
            const moy = calcMoyenne(r);
            return (
              <tr key={r.stagiaire_id} className={`border-b border-slate-50 ${idx % 2 === 0 ? 'bg-white' : 'bg-slate-50/30'} hover:bg-blue-50/30 transition-colors`}>
                <td className="sticky left-0 z-10 bg-inherit px-3 py-2 font-mono text-slate-500 whitespace-nowrap">{r.nim || '-'}</td>
                <td className="sticky left-[60px] z-10 bg-inherit px-3 py-2 font-semibold text-slate-800 whitespace-nowrap">
                  <Link to={`/bulletin-notes?id=${r.stagiaire_id}`} className="hover:text-[#8DC63F] hover:underline" data-testid={`bulletin-${r.stagiaire_id}`}>
                    {r.prenom} {r.nomFamille}
                  </Link>
                </td>
                {columns.map(col => {
                  const cellNotes = r.notes[col.key] || [];
                  return (
                    <td key={col.key} className="px-1 py-1 text-center border-l border-slate-50">
                      {cellNotes.length === 0 ? (
                        <span className="text-slate-300">-</span>
                      ) : (
                        <div className="flex flex-wrap justify-center gap-0.5">
                          {[...cellNotes].sort((a, b) => (a.date || '').localeCompare(b.date || '')).map(n => (
                            <span
                              key={n.note_id}
                              className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-bold ${noteColor(n.note)}`}
                              title={`${n.note}/${n.bareme || 10} — ${n.date || ''}\nFormateur: ${n.formateur_nom || ''}\n${n.commentaire || ''}`}
                            >
                              {n.note}
                              {n.date && <span className="font-normal text-[8px] opacity-70 ml-0.5">({n.date.slice(5)})</span>}
                            </span>
                          ))}
                        </div>
                      )}
                    </td>
                  );
                })}
                <td className={`px-3 py-2 text-center border-l-2 border-slate-300 ${moyenneColor(moy)}`}>
                  {moy > 0 ? moy.toFixed(1) : '-'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);
